import { Button, Col, DatePicker, Row, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { getAvatarNames } from 'src/api/reports'
import { GENDER_TYPE, PHONE_MODEL, userType } from 'src/constants'
import {
  SearchOutlined
} from '@ant-design/icons'
import { fetchCountryProvider } from 'src/api/authen'
interface AvatarReportSearchProps {
    appendSearchForm:(obj: any) => void
    submitSearchForm: () => void
}
const AvatarReportSearch: React.FC<AvatarReportSearchProps> = ({ 
    appendSearchForm, submitSearchForm 
}) => {
    const [loading, setLoading] = useState(false)
    const [country, setCountry] = useState('')  
    const [gender, setGender] = useState('Male')
    const [avatar, setAvatar] = useState<string>('')
    const [deviceType, setDeviceType] = useState<string>('')
    const [avatarList, setAvatarList] = useState<string[]>([])
     const [buttonAction, setButtonAction] = useState('Select')
     const [countries, setCountries] = useState([])
 const [selectedFilterValue, setSelectedFilterValue] = useState('ALL');

const filterAvatarOption = (inputValue, option) => {
    return option.label.toLowerCase().includes(inputValue.toLowerCase())
  }
  const allUserTypeOptions = [
      { label: 'All', value: 'ALL' },
      ...userType,
    ];
const handleAvatarChange = (value) => {
    setAvatar(value)
    appendSearchForm({ avatarName: value })
  }
  const handleFilterChange = (value) => {
        setSelectedFilterValue(value);
        let userTypesForSearch;
    
        if (value === 'ALL') {
         
          userTypesForSearch = userType.map(option => option.value);
        } else {
          
          userTypesForSearch = [value];
        }
    
        appendSearchForm({ userAccessType: userTypesForSearch });
        
      };
      useEffect(() => {
      const fetchAvatarNames = async () => {
        try {
          const data = await getAvatarNames()
          if (data) {
            setAvatarList(data)
          }
        } catch (error) {
          console.error('Error fetching avatar names:', error)
        }
      }
        fetchAvatarNames()
        const fetchCountry = async () => {
              try {
                const data = await fetchCountryProvider()
                const countryOptions = data.data.map((item) => ({
                  label: item.countryName,
                  value: item.countryCode,
                }))
                setCountries(countryOptions)
              } catch (error) {
                console.error('Error fetching data:', error)
              }
            }
            fetchCountry()
        }, [])
        const handleSearchClick = () => {
    appendSearchForm({ buttonAction: ' ' })
    submitSearchForm()
    setButtonAction(null)
  }

return (
         <div className="master-search-wrap">
       <Row gutter={15}>
        <Col span={4}>
                  <Select
                    placeholder="Select Avatar"
                    onChange={handleAvatarChange}
                    filterOption={filterAvatarOption}
                    allowClear
                    onClear={() => {
                      setAvatar('')
                      appendSearchForm({ avatarName: '' })
                    }}
                    className="search-input"
                    showSearch
                  >
                    {avatarList.map((avatar) => (
                      <Select.Option value={avatar} key={avatar} label={avatar}>
                        {avatar}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
        <Col span={4}>
        <Select
          placeholder="Select Gender"
          onChange={(value) => appendSearchForm({ gender: value })}
          allowClear
          onClear={() => appendSearchForm({ gender: '' })}
          className="search-input"
        >
          {GENDER_TYPE.map((val) => (
            <Select.Option value={val} key={val}>
              {val}
            </Select.Option>
          ))}
        </Select>
     </Col>
     <Col span={4}>
        <Select
          placeholder="Select Device Type"
          onChange={(value) => appendSearchForm({ deviceType: value })}
          allowClear
          onClear={() => appendSearchForm({ deviceType: '' })}
          className="search-input"
        >
          {PHONE_MODEL.map(({label,value}) => (
                      <Select.Option value={value} key={value}>
                        {label}
                      </Select.Option>
                    ))}
        </Select>
        </Col>
        <Col span={4}>
              <Select
                placeholder="Country"
                onChange={(value) => {
                  appendSearchForm({ country: value });
                  if (!value) submitSearchForm();
                }}
                allowClear
                onClear={() => {
                  appendSearchForm({ country: '' });
                  submitSearchForm();
                }}
                showSearch
                className="search-input"
                style={{ width: '100%' }}
              >
                {countries.map((country) => (
                  <Select.Option value={country.value} key={country.value}>
                    {country.label}
                  </Select.Option>
                ))}
              </Select>
            </Col>
       <Col span={8}>
          <DatePicker.RangePicker
            
            allowClear
            format="YYYY-MM-DD"
            placeholder={['Start Date', 'End Date']}
            onChange={(dates) => {
              const startDate = dates?.[0]?.format('YYYY-MM-DD') || null
              const endDate = dates?.[1]?.format('YYYY-MM-DD') || null
              appendSearchForm({ startDate, endDate })
            }}
          />
        </Col>
       
               <Col span={4}>
                 <Button
                   type="primary"
                   icon={<SearchOutlined />}
                   onClick={handleSearchClick}
                   className="btn-primary"
                  //  size="large"
                 >
                   Search
                 </Button>
               </Col>
       
             </Row>
       </div>
  )
}
AvatarReportSearch.displayName = 'AvatarReportSearch'
export default AvatarReportSearch